import { Component, OnInit,Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-bulletinsingle',
  templateUrl: './bulletinsingle.component.html',
  styleUrls: ['./bulletinsingle.component.css']
})
export class BulletinsingleComponent implements OnInit {

  constructor( private homepageService: HomepageService ) {}
	bulletinlist: any = [];
  @Input() buId: number;
  ngOnInit() {
  	this.getBulletinlist();
  }
    
  getBulletinlist(){
    let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
    getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'BU' && this.buId  == evt.id){
               this.bulletinlist = evt.content;                              
             }
            
          });
    
    }

}
